<div class="booble-backdrop">

  <div class=" xp-modal xp-modal-cadastro">
    <div class="modal-dialog modal-xl modal-dialog-centered modal--xl modal--lg modal--md modal--sm">
      <div class="modal-content">
        <div class="modal-header">

          <div class="col-md-12">
            <div class="header-title">Detalhe da ordem: Envio</div>
            <p class="header-subtitle">Insira as informações abaixo para gerar ordem com a Xavi Pay.</p>
          </div>
          <button type="button" (click)="closeModal()" class="btn-close" data-dismiss="modal"
            aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="modal-dialog-scrollable-general">
            <div class="form tpl-form-2 pt-0">

              <form [formGroup]="orderForm">

                <div class="form-row">

                  <div class="col-md-12">
                    <div class="form-subtitle">Dados do recebedor</div>
                  </div>

                  <div class="col-lg-4 col-md-6">
                    <div class="line">
                      <div class="label">Banco<span class="text-danger"> *</span></div>
                      <input formControlName="receiverBankName" type="text" class="form-control" name="" required />
                      <span class="text-danger"
                        *ngIf="(orderFormControl.receiverBankName.touched) && orderFormControl.receiverBankName.errors?.required">
                        Banco obrigatório
                      </span>
                      <!-- <select formControlName="receiverBankName" placeholder="Selecione"
                        class="js-control-receiver-bank custom-select">
                        <option *ngFor="let bank of banks" [value]="bank.bank">
                          {{bank.bank}}
                        </option>
  
                      </select> -->
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-6">
                    <div class="line">
                      <div class="label">País<span class="text-danger"> *</span></div>
                      <select placeholder="Selecione" name="" formControlName="country"
                        class="custom-select js-control-receiver-country">
                        <option *ngFor="let country of countries" [ngValue]="country.nome">
                          {{country.nome}}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="col-lg-2 col-md-6">
                    <div class="line">
                      <div class="label">Número da conta<span class="text-danger"> *</span></div>
                      <input formControlName="receiverAccount" type="text" class="form-control" name="" required />
                      <span class="text-danger"
                        *ngIf="(orderFormControl.receiverAccount.touched) && orderFormControl.receiverAccount.errors?.required">
                        Número da conta obrigatório
                      </span>
                    </div>
                  </div>

                  <div class="col-lg-2 col-md-6">
                    <div class="line">
                      <div class="label">Código SWIFT<span class="text-danger"> *</span></div>
                      <input formControlName="receiverSwift" type="text" class="form-control" name="" required />
                      <span class="text-danger"
                        *ngIf="(orderFormControl.receiverSwift.touched) && orderFormControl.receiverSwift.errors?.required">
                        Código SWIFT obrigatório
                      </span>
                    </div>
                  </div>

                  <div class="col-lg-4 col-md-6">
                    <div class="line">
                      <div class="label">Complemento do canal bancário <img
                          title="O complemento do canal bacário pode ser: Número da fatura / TRANSIT (CAD) / Nome Estudante / BSB (AUS) / APOLICE / RUT (CHILE) / CUIT (ARG) / Referência"
                          src="assets/image/information.svg" /></div>
                      <input formControlName="receiverBankChannel" type="text" class="form-control" name="" />
                    </div>
                  </div>

                  <div class="col-lg-4 col-md-6">
                    <div class="line">
                      <div class="label">Banco intermediário</div>
                      <input formControlName="receiverIntermediaryBank" type="text" class="form-control" name="" />
                    </div>
                  </div>

                  <div class="col-lg-2 col-md-6">
                    <div class="line">
                      <div class="label">Número da conta</div>
                      <input formControlName="receiverIntermediaryAccount" type="text" class="form-control" name="" />

                    </div>
                  </div>

                  <div class="col-lg-2 col-md-6">
                    <div class="line">
                      <div class="label">Código SWIFT</div>
                      <input formControlName="receiverIntermediarySwift" type="text" class="form-control" name="" />

                    </div>
                  </div>

                  <div *ngIf="!IBAN" class="col-lg-4 col-md-6">
                    <div class="line">
                      <div class="label">ABA</div>
                      <input formControlName="receiverABA" type="text" class="form-control" name="" />

                    </div>
                  </div>

                  <div *ngIf="IBAN" class="col-lg-4 col-md-6">
                    <div class="line">
                      <div class="label">IBAN</div>
                      <input formControlName="receiverIBAN" type="text" class="form-control" name="" />

                    </div>
                  </div>

                  <div class="col-lg-2 col-md-6">
                    <div class="line">
                      <div class="label"><span class="text-danger">* </span>Valor</div>
                      <input formControlName="amount" currencyMask
                        (blur)="orderFormControl.amount.value < 0 ? orderFormControl.amount.setValue(0) : orderFormControl.amount.value; orderFormControl.amount.value >= 999999 ? orderFormControl.amount.setValue(999999) : orderFormControl.amount.value;"
                        [options]="{ prefix: '', thousands: '.', decimal: ',' }" type="text" class="form-control"
                        name="" required />
                      <span class="text-danger"
                        *ngIf="(orderFormControl.amount.touched) && orderFormControl.amount.errors?.required">
                        Valor obrigatório
                      </span>
                    </div>
                  </div>

                  <div class="col-lg-2 col-md-6">
                    <div class="line">
                      <div class="label">Moeda<span class="text-danger"> *</span></div>
                      <select formControlName="currency" name="currency" placeholder="Selecione"
                        class="js-control-currency custom-select">
                        <option *ngFor="let moeda of moedas" [value]="moeda">{{moeda}}</option>
                      </select>
                    </div>
                  </div>

                  <div class="col-md-12">
                    <div class="form-subtitle">Dados do pagador</div>
                  </div>

                  <div class="col-lg-4 col-md-6">
                    <div class="line">
                      <div class="label">Matriz/Filial<span class="text-danger"> *</span></div>
                      <select formControlName="senderBranch" placeholder="Selecione"
                        class="js-control-sender-branch custom-select">
                        <option *ngFor="let branch of branchs" [ngValue]="branch">
                          {{branch}}
                        </option>

                      </select>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-6">
                    <div class="line">
                      <div class="label">Banco de origem<span class="text-danger"> *</span></div>
                      <input formControlName="senderBankName" type="text" class="form-control" name="" required
                        readonly />
                      <span class="text-danger"
                        *ngIf="(orderFormControl.senderBankName.touched) && orderFormControl.senderBankName.errors?.required">
                        Banco obrigatório
                      </span>
                    </div>
                  </div>

                  <div class="col-lg-2 col-md-6">
                    <div class="line">
                      <div class="label">Agência<span class="text-danger"> *</span></div>
                      <input formControlName="senderBankAgency" type="text" class="form-control" name="" required
                        readonly />
                      <span class="text-danger"
                        *ngIf="(orderFormControl.senderBankAgency.touched) && orderFormControl.senderBankAgency.errors?.required">
                        Agência obrigatória
                      </span>
                    </div>
                  </div>

                  <div class="col-lg-2 col-md-6">
                    <div class="line">
                      <div class="label">Número da conta<span class="text-danger"> *</span></div>
                      <input formControlName="senderBankAccount" type="text" class="form-control" name="" required
                        readonly />
                      <span class="text-danger"
                        *ngIf="(orderFormControl.senderBankAccount.touched) && orderFormControl.senderBankAccount.errors?.required">
                        Número da conta obrigatório
                      </span>
                    </div>
                  </div>

                </div>

                <div class="dashboard-line-btn">
                  <div class="form-row form-invoice">
                    <div class="cols">
                      <div class="form-group mb-0">
                        <button type="button" (click)="openNewOrderOutboundModal()" class="btn-xp-m2 btn-gray-new">
                          Voltar
                        </button>
                      </div>
                    </div>
                    <div class="cols">
                      <div class="form-group mb-0">
                        <button [ngClass]="{'btn-gray-disabled': orderForm.invalid , 'btn-blue-30': !orderForm.invalid}"
                          [disabled]="orderForm.invalid || loading" (click)="sendInvoice()" type="button"
                          class="btn-xp-m2 btn-blue-30">
                          Gerar invoice
                          <span class="spinner-border spinner-border-sm" *ngIf="loading"></span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>